<template>
  <div class="dayInfoCon">
    <div class="dayInfoT">
      <div class="itemL">总{{ typeChangeText }}({{ unit }})</div>
      <div class="itemR">
        <div class="itemRI">
          <div class="dateShow">{{ totalObj.maxDate }}</div>
          <div class="numShow">{{ totalObj.max }}</div>
          <div class="typeShow">最大值</div>
        </div>
        <div class="itemRI">
          <div class="dateShow">{{ totalObj.minDate }}</div>
          <div class="numShow">{{ totalObj.min }}</div>
          <div class="typeShow">最小值</div>
        </div>
        <div class="itemRI">
          <div class="numShow">{{ totalObj.avg }}</div>
          <div class="typeShow">平均值</div>
        </div>
        <div class="itemRI">
          <div class="dateShow">{{ totalObj.standardDiffContent }}</div>
          <div class="numShow">{{ totalObj.standardDiff }}</div>
          <div class="typeShow">标准差</div>
        </div>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="dayInfoB">
      <el-carousel trigger="click" height="192px" :autoplay="false"  v-if="unit == 'L'">
        <el-carousel-item
          v-for="(i,ind) in dataList"
          :key="ind"
          :autoplay="false"
        >
          <!-- <div class="dayInfoItem" v-for="(i,index) in item" :key="index"> -->
            <div class="itemLH">{{ i.name }}</div>
            <div class="itemRCon">
              <div class="itemR">
                <div class="itemRI">
                  <div class="dateShow">{{ i.value.maxDate }}</div>
                  <div class="numShow">{{ i.value.max }}L</div>
                  <div class="typeShow">最大值</div>
                </div>
                <div class="itemRI">
                  <div class="dateShow">{{ i.value.minDate }}</div>
                  <div class="numShow">{{ i.value.min }}L</div>
                  <div class="typeShow">最小值</div>
                </div>
                <div class="itemRI">
                  <div class="numShow">{{ i.value.avg }}L</div>
                  <div class="typeShow">平均值</div>
                </div>
                <div class="itemRI">
                  <div class="dateShow">{{ i.value.standardDiffContent }}</div>
                  <div class="numShow">{{ i.value.standardDiff }}</div>
                  <div class="typeShow">标准差</div>
                </div>
              </div>
              <div class="itemR">
                <div class="itemRI">
                  <div class="dateShow">{{ i.hourValue.maxDate }}</div>
                  <div class="numShow">{{ i.hourValue.max }}L/H</div>
                  <div class="typeShow">最大值</div>
                </div>
                <div class="itemRI">
                  <div class="dateShow">{{ i.hourValue.minDate }}</div>
                  <div class="numShow">{{ i.hourValue.min }}L/H</div>
                  <div class="typeShow">最小值</div>
                </div>
                <div class="itemRI">
                  <div class="numShow">{{ i.hourValue.avg }}L/H</div>
                  <div class="typeShow">平均值</div>
                </div>
                <div class="itemRI">
                  <div class="dateShow">{{ i.hourValue.standardDiffContent }}</div>
                  <div class="numShow">{{ i.hourValue.standardDiff }}</div>
                  <div class="typeShow">标准差</div>
                </div>
              </div>
            </div>
            
            <div style="clear: both"></div>
          <!-- </div> -->
        </el-carousel-item>
      </el-carousel>

      <el-carousel trigger="click" height="192px" :autoplay="false" v-if="unit != 'L'">
        <el-carousel-item
          v-for="(item,ind) in dataList"
          :key="ind"
          :autoplay="false"
        >
          <div class="dayInfoItem" v-for="(i,index) in item" :key="index">
            <div class="itemL">{{ i.name }}</div>
            <div class="itemR">
              <div class="itemRI">
                <div class="dateShow">{{ i.value.maxDate }}</div>
                <div class="numShow">{{ i.value.max }}</div>
                <div class="typeShow">最大值</div>
              </div>
              <div class="itemRI">
                <div class="dateShow">{{ i.value.minDate }}</div>
                <div class="numShow">{{ i.value.min }}</div>
                <div class="typeShow">最小值</div>
              </div>
              <div class="itemRI">
                <div class="numShow">{{ i.value.avg }}</div>
                <div class="typeShow">平均值</div>
              </div>
              <div class="itemRI">
                <div class="dateShow">{{ i.value.standardDiffContent }}</div>
                <div class="numShow">{{ i.value.standardDiff }}</div>
                <div class="typeShow">标准差</div>
              </div>
            </div>
            <div style="clear: both"></div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",

  data() {
    return {
      totalObj: {},
      dataList: [],
    };
  },
  props: ["setAnalysis", "typeChangeText", "unit"],
  computed: {},
  created() {},
  mounted() {},
  methods: {},
  watch: {
    setAnalysis: {
      handler(newVal) {
        console.log(newVal);
        this.totalObj = newVal.total;
        let setArr = newVal.values;
        let getArr = [];
        let getType = this.unit == 'L'?'1':'2'
        if(getType == 1){
          getArr = setArr
        }else{
          for (let i = 0; i < setArr.length; i++) {
            if (i % 2 == 0) {
              if (setArr[i + 1]) {
                let arr = [setArr[i], setArr[i + 1]];
                getArr.push(arr);
              } else {
                let arr = [setArr[i]];
                getArr.push(arr);
              }
            }
          }
        }
        
        this.dataList = getArr;
        console.log(getArr);
      },
      deep: true,
    },
  },
  components: {},
};
</script>

<style lang="scss" scoped="">
.dayInfoCon {
  width: 100%;
  height: 100%;
  border-top: 1px solid #f5f5f5;
  border-left: 1px solid #f5f5f5;
  .dayInfoT {
    width: 100%;
    height: 128px;
    .itemL {
      width: 112px;
      height: 128px;
      padding-top: 60px;
      text-align: center;
      font-size: 16px;
      font-family: Noto Sans SC;
      font-weight: bold;
      color: #404040;
      line-height: 20px;
      float: left;
      background-color: #f5f5f5;
      table-layout: fixed;
      word-wrap: break-word ;
      word-break: normal;
    }
    .itemLH{
      width: 112px;
      height: 255px;
      padding-top: 60px;
      text-align: center;
      font-size: 16px;
      font-family: Noto Sans SC;
      font-weight: bold;
      color: #404040;
      line-height: 20px;
      float: left;
      background-color: #f5f5f5;
      table-layout: fixed;
      word-wrap: break-word ;
      word-break: normal;
    }
    .itemR {
      width: 431px;
      height: 128px;
      float: left;
      display: flex;
      .itemRI {
        flex: 1;
        border-right: 1px solid #f5f5f5;
        border-bottom: 1px solid #f5f5f5;
        position: relative;
        .dateShow {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #8c8c8c;
          position: absolute;
          top: 22px;
          left: 24px;
        }
        .typeShow {
          height: 20px;
          line-height: 20px;
          font-size: 14px;
          color: #8c8c8c;
          position: absolute;
          bottom: 22px;
          left: 24px;
        }
        .numShow {
          height: 36px;
          line-height: 36px;
          font-size: 22px;
          color: #404040;
          position: absolute;
          bottom: 46px;
          left: 24px;
          font-weight: bold;
        }
      }
    }
  }
  .dayInfoB {
    width: 100%;
    height: 192px;
    // .dayInfoItem {
    //   width: 100%;
    //   height: 96px;
      .itemL {
        width: 112px;
        height: 96px;
        text-align: center;
        font-size: 16px;
        font-family: Noto Sans SC;
        font-weight: bold;
        color: #404040;
        line-height: 96px;
        float: left;
        background-color: #f5f5f5;
      }
      .itemLH{
        width: 112px;
        height: 191px;
        padding-top: 80px;
        text-align: center;
        font-size: 16px;
        font-family: Noto Sans SC;
        font-weight: bold;
        color: #404040;
        line-height: 20px;
        float: left;
        background-color: #f5f5f5;
        table-layout: fixed;
        word-wrap: break-word ;
        word-break: normal;
      }
      .itemRCon{
        width: 431px;
        height: 193px;
        float: left;
        // display: flex;
        .itemR {
          width: 431px !important;
          height: 96px;
          // float: left;
          display: flex;
          .itemRI {
            flex: 1;
            border-right: 1px solid #f5f5f5;
            border-bottom: 1px solid #f5f5f5;
            position: relative;
            .dateShow {
              height: 16px;
              line-height: 16px;
              font-size: 12px;
              color: #8c8c8c;
              position: absolute;
              top: 16px;
              left: 24px;
            }
            .typeShow {
              height: 16px;
              line-height: 16px;
              font-size: 12px;
              color: #8c8c8c;
              position: absolute;
              bottom: 16px;
              left: 24px;
            }
            .numShow {
              height: 24px;
              line-height: 24px;
              font-size: 16px;
              color: #404040;
              position: absolute;
              bottom: 36px;
              left: 24px;
              font-weight: bold;
            }
          }
        }
      }
      
    // }
    .dayInfoItem {
      width: 100%;
      height: 96px;
      .itemL {
        width: 112px;
        height: 96px;
        text-align: center;
        font-size: 16px;
        font-family: Noto Sans SC;
        font-weight: bold;
        color: #404040;
        line-height: 96px;
        float: left;
        background-color: #f5f5f5;
      }
      .itemLH{
        width: 112px;
        height: 191px;
        padding-top: 60px;
        text-align: center;
        font-size: 16px;
        font-family: Noto Sans SC;
        font-weight: bold;
        color: #404040;
        line-height: 20px;
        float: left;
        background-color: #f5f5f5;
        table-layout: fixed;
        word-wrap: break-word ;
        word-break: normal;
      }
      .itemRCon{
        width: 431px;
        height: 191px;
        float: left;
        display: flex;
      }
      .itemR {
        width: 431px;
        height: 96px;
        // float: left;
        display: flex;
        .itemRI {
          flex: 1;
          border-right: 1px solid #f5f5f5;
          border-bottom: 1px solid #f5f5f5;
          position: relative;
          .dateShow {
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            color: #8c8c8c;
            position: absolute;
            top: 16px;
            left: 24px;
          }
          .typeShow {
            height: 16px;
            line-height: 16px;
            font-size: 12px;
            color: #8c8c8c;
            position: absolute;
            bottom: 16px;
            left: 24px;
          }
          .numShow {
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            color: #404040;
            position: absolute;
            bottom: 36px;
            left: 24px;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>